module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_4.7ec2cb76.png";